export default {"src":"/_next/static/media/cpu.72278383.svg","height":24,"width":24};